import { Button, Card, Skeleton, Stack, SvgIcon, Typography } from '@mui/material';
import Plus from '@untitled-ui/icons-react/build/esm/Plus';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths, permissions } from 'src/paths';
import { resetStartOfCareDate } from 'src/redux/actions/documentationAction';
import { switchTherapistDisciplineAction } from 'src/redux/actions/patientAction';
import { getEpisodeOfCare, resetEditEpisodeOfCare } from 'src/redux/actions/patientEpisodeOfCare';
import ListingTable from 'src/sections/dashboard/patients/patient-details-listing-table';

const { patients, patientDetails, episodeOfCare, details, addNewEpisodeOfCare } = paths;
const { CREATE_EPISODE_OF_CARE } = permissions;

const EpisodeOfCare = () => {
  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const episodeOfCareData = useSelector((state: any) => state?.getEpisodeOfCare?.response);
  const episodeOfCareLoading = useSelector((state: any) => state?.getEpisodeOfCare?.loading);
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getEpisodeOfCare({
        patientId: getPatientId,
      })
    );
  }, [getPatientId]);

  const onRowClick = (episodeOfCareData: any) => {
    dispatch(switchTherapistDisciplineAction(''));
    dispatch(resetStartOfCareDate());
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: episodeOfCareData?.uuid,
        getPatientId,
      },
    });
  };

  return (
    <Card sx={{ padding: '1.5rem' }}>
      <Stack>
        {!episodeOfCareLoading && (
          <Stack
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
          >
            <Stack
              gap="1rem"
              alignItems="center"
              flexDirection="row"
              sx={{ marginBottom: '1rem' }}
            >
              <h3 style={{ margin: '0px' }}>Episode Of Care</h3>
              <Stack
                flexDirection="row"
                sx={{
                  borderRadius: '12px',
                  display: 'flex',
                  border: '1px solid #00000042',
                  color: '#111927',
                  padding: '3px 10px',
                }}
              >
                <Typography variant="subtitle2">{`${episodeOfCareData?.totalElements} Episodes Of Care`}</Typography>
              </Stack>
            </Stack>
            {patientData?.active && (
              <Stack>
                <Button
                  color="inherit"
                  startIcon={
                    <SvgIcon>
                      <Plus />
                    </SvgIcon>
                  }
                  onClick={(event) => {
                    dispatch(resetEditEpisodeOfCare());
                    navigate(
                      `${patients}/${patientDetails}${episodeOfCare}${addNewEpisodeOfCare}`,
                      {
                        state: { getPatientId },
                      }
                    );
                  }}
                  disabled={!permissionData?.includes(CREATE_EPISODE_OF_CARE)}
                  sx={{ color: 'primary.dark' }}
                >
                  Add New Episode of Care
                </Button>
              </Stack>
            )}
          </Stack>
        )}

        {!episodeOfCareLoading ? (
          <>
            {episodeOfCareData?.content?.length > 0 ? (
              <ListingTable
                items={episodeOfCareData?.content}
                count={episodeOfCareData?.totalElements}
                page={page}
                onRowClick={onRowClick}
                rowsPerPage={rowPerPage}
                tableHead={[
                  {
                    label: 'NAME',
                    value: 'episodeTitle',
                  },
                  {
                    label: 'RESIDENCE',
                    value: 'disciplineOfComplete',
                  },
                  {
                    label: 'SCREENING TYPE',
                    value: 'screeningTypes',
                  },
                  {
                    label: 'START DATE',
                    value: 'startDate',
                  },
                  {
                    label: 'END DATE',
                    value: 'endDate',
                  },
                  {
                    label: 'Status',
                    value: 'status',
                    action: 'episodeOfCare',
                  },
                  {
                    label: '',
                    value: 'arrow',
                  },
                ]}
              />
            ) : (
              <Typography sx={{ margin: '1rem auto' }}>No Record Founds</Typography>
            )}
          </>
        ) : (
          <>
            {Array(12)
              .fill(null)
              .map((_, index) => (
                <Skeleton key={index} />
              ))}
          </>
        )}
      </Stack>
    </Card>
  );
};

export default EpisodeOfCare;
